define('app/factories/vendor_factory',[
    'app/setup',
    'app/views/vendor_view',
    'app/views/discount_list_view',
    'app/views/dc_verify_phone_number_view',
    'app/views/fix_sidebar'
  ],
  function (takhfifan) {
    $('.tkh-vendor').each(function () {
      return new takhfifan.vendorView({
        el: $(this)
      });
    });

    $('.tkh-dc-vendor').each(function () {
      var $el = $(this);

      new takhfifan.DiscountListView({
        el: $(this).find('.tkh-vendor-discounts'),
        vendorId: $el.data("vendorId"),
        productCount: $el.data("productCount")
      });

      $('.tkh-dc-verification-modal').each(function () {
        new takhfifan.dcVrifyPhoneNumber({
          el: $(this)
        })
      },this);

      $('.tkh-fix-sidebar-custom').each(function () {
        var $this = $(this),
          $thisSideBar = $(this).find('.tkh-fix-sidebar-custom__side'),
          $thisSideBarInner = $(this).find('.tkh-fix-sidebar-custom__inner');

        $this.find('.tkh-fix-sidebar-custom__child').children().each(function () {
          $(this).clone().addClass('hide-on-mobile').appendTo($thisSideBarInner);
          $(this).addClass('hide-on-desktop');
        });

        new takhfifan.fixSidebar({
          el: $thisSideBar,
          containerSelector: '.tkh-fix-sidebar-custom',
          innerWrapperSelector: '.tkh-fix-sidebar-custom__inner',
          stickyClass: 'side-is-fixed',
          topSpacing: 90
        });
      });
    });
  });
